import { ErrorsCbs } from '../errorTypes';
export const stripCallbacksFromPayload = <
    T extends { cb?: (() => void) | ((...args: any[]) => void); errorsCbs?: ErrorsCbs },
>(
    payload: T,
) => {
    const { cb, errorsCbs, ...rest } = payload;
    return rest;
};
